class TableHeader {
  constructor({
    text,
    value,
    sortable = true,
    align = 'center',
    key,
    columnOrderText = text
  }) {
    this.text = text
    this.value = value
    this.sortable = sortable
    this.align = align
    this.key = key
    this.columnOrderText = columnOrderText
  }
}

export const invoiceTableKeys = {
  NUMBER: 'number',
  SALE_STATE: 'saleState',
  STATE: 'state',
  CUSTOMER_NAME: 'customerName',
  COUNTERPARTY_NAME: 'counterpartyName',
  PARTNER_NAME: 'partnerName',
  FORMATTED_AMOUNT: 'formattedAmount',
  FORMATTED_CREATED_AT: 'formattedCreatedAt',
  FORMATTED_DUE_DATE: 'formattedDueDate',
  CUSTOMER_GRADE: 'customerGrade',
  COUNTERPARTY_GRADE: 'counterpartyGrade',
  CREDIT_NOTE_IDS: 'creditNoteIds',
  ACTIONS: 'actions'
}

export const tableHeaders = [
  new TableHeader({
    text: 'Invoice Nr',
    value: 'number',
    align: 'left',
    key: invoiceTableKeys.NUMBER
  }),
  new TableHeader({
    text: 'Checks',
    value: 'sale_state',
    key: invoiceTableKeys.SALE_STATE
  }),
  new TableHeader({
    text: 'State',
    value: 'state',
    sortable: false,
    key: invoiceTableKeys.STATE
  }),
  new TableHeader({
    text: 'Issuer',
    value: 'customer.name',
    align: 'left',
    key: invoiceTableKeys.CUSTOMER_NAME
  }),
  new TableHeader({
    text: 'Debtor',
    value: 'counterparty.name',
    align: 'left',
    key: invoiceTableKeys.COUNTERPARTY_NAME
  }),
  new TableHeader({
    text: 'Partner',
    value: 'partner.name',
    align: 'left',
    key: invoiceTableKeys.PARTNER_NAME
  }),
  new TableHeader({
    text: 'Value',
    value: 'amount',
    align: 'right',
    key: invoiceTableKeys.FORMATTED_AMOUNT
  }),
  new TableHeader({
    text: 'Created at',
    value: 'created_at',
    key: invoiceTableKeys.FORMATTED_CREATED_AT
  }),
  new TableHeader({
    text: 'Due date',
    value: 'due_date',
    key: invoiceTableKeys.FORMATTED_DUE_DATE
  }),
  new TableHeader({
    text: 'Issuer grade',
    value: 'customer_grade',
    sortable: false,
    align: 'left',
    key: invoiceTableKeys.CUSTOMER_GRADE
  }),
  new TableHeader({
    text: 'Debtor grade',
    value: 'counterparty_grade',
    sortable: false,
    align: 'left',
    key: invoiceTableKeys.COUNTERPARTY_GRADE
  }),
  new TableHeader({
    text: 'Credit Note',
    value: 'creditnote_matched',
    align: 'left',
    key: invoiceTableKeys.CREDIT_NOTE_IDS
  }),
  new TableHeader({
    text: '',
    value: 'actions',
    sortable: false,
    key: invoiceTableKeys.ACTIONS,
    columnOrderText: 'Actions'
  })
]
